import React, { useContext } from 'react';
import { Dialog, Link, List, ListItem, useMediaQuery, useTheme } from '@mui/material';
import { HighlightOff as HighlightOffIcon, CheckCircleOutline as CheckCircleOutlineIcon } from '@mui/icons-material';

import GamesContext from '../../store/games-context';
import { SplitHit } from '../../types/split';
import Run from '../../types/run';
import { modalTypes } from '../../types/modalTypes';
import { getRunStatus } from '../../utils/utils';

import styles from './statistics.components.module.scss';
import { STATUS } from '../../utils/constants';

function GameRunModal({ runs, displayText, onClose, type }: { runs: SplitHit[] | Run[], displayText: string, onClose: any, type: modalTypes }) {
  const gamesContext = useContext(GamesContext);
  const games = gamesContext.games;
  const isMobile = useMediaQuery(useTheme().breakpoints.down('md'));
  const extraText = 'Runs';
  return (
    <Dialog open onClose={() => onClose([])} className={styles.hitClipsContainer} maxWidth={isMobile ? 'xs' : 'lg'} fullScreen={isMobile ? true : false}>
      <div className={styles.content}>
        <h3>{displayText} {extraText}:</h3>
        <List>
          {(runs.map(gameRun =>
          {
            const runStatus = getRunStatus(gameRun as Run, games);
            return (
                <ListItem key={JSON.stringify(gameRun)} className={styles.itemList}>
                  <span className={`${styles[runStatus.toLowerCase()]} ${styles.icon}`}>
                  {
                    (runStatus === STATUS.FAILED ? <HighlightOffIcon/> : (runStatus === STATUS.SUCCEEDED ? <CheckCircleOutlineIcon/> : null))
                  }
                  </span>
                  <span className={styles.modalItemText}>{gameRun.date}, {games[(gameRun as Run).selectedGame].acronym}:</span> <Link className={styles.modalLink} href={gameRun.clip}> {runStatus === STATUS.FAILED ? 'Hit clip' : 'Run clip' } </Link>
              </ListItem>
            );
          }
          ))}
        </List>
      </div>
    </Dialog>
  );
}

export default GameRunModal;